module.exports = __webpack_public_path__ + "static/img/production_05.63948ac3.jpg";